import React from 'react';
import { Flex } from '@common/components/Flex';
import { I18n } from 'react-redux-i18n';
import { FormControl } from '@common/components/form-control';
import { AdditionalPatientDetailsProps, useAdditionalPatientDetailsController } from './additional-patient-details.controller';
import { Loading } from '@common/components/loading';

import './additional-patient-details.styles.scss';

export const AdditionalPatientDetails: React.FC<AdditionalPatientDetailsProps> = (props) => { 
  const {
    getFieldValue,
    defaultDsAdditionalData,
    handleFieldChange,
  } = useAdditionalPatientDetailsController(props);

  return (
    <div className="InviteStatusAdditionalPatientDetails">
      <h6 className="InviteStatusAdditionalPatientDetails__title">{I18n.t('Enter additional data')}</h6>
      {!defaultDsAdditionalData && (
        <Flex width="100%" justify="center">
          <Loading margin="40px" size={25} />
        </Flex>
      )}
      {defaultDsAdditionalData?.fields.map((dsField) => {
        const fieldValue = getFieldValue(dsField.field);

        return (
          <Flex justify="space-between" key={dsField.id} className="InviteStatusAdditionalPatientDetails__section">
            <h6 className="InviteStatusAdditionalPatientDetails__label">{dsField.headingpds}</h6>
            <FormControl
              className="InviteStatusAdditionalPatientDetails__input"
              defaultValue={fieldValue}
              onChange={(e) => handleFieldChange(dsField, e.target.value)} 
            />
          </Flex>
        );
      })}
    </div>
  );
};